<!-- 销售订单 -->
<template>
  <div>
    <el-row ref="searchBox" class="search-box">
      <el-col :span="4">
        <el-input v-model="condition.sn" clearable placeholder="请输入销售订单号" />
      </el-col>
      <el-col :span="4">
        <el-input v-model="condition.sapOrderSn" clearable placeholder="请输入SAP销售订单号" />
      </el-col>
      <el-col :span="4">
        <el-select v-model="condition.status" placeholder="请选择订单状态">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="getPage('refresh')">查询</el-button>
        <el-button type="primary" @click="handleEdit(null)">新增</el-button>
      </el-col>
    </el-row>
    <el-table ref="listTable" v-loading="loading" :data="tableData" :height="tableHeight" border>
      <!-- <el-table-column type="selection" width="55" /> -->
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column label="订单状态" align="left" prop="status" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">制单</span>
          <span v-if="scope.row.status == 2">审核中</span>
          <span v-if="scope.row.status == 3">审核完成</span>
        </template>
      </el-table-column>
      <el-table-column label="单据类型" align="left" prop="salesName" show-overflow-tooltip width="120" />
      <el-table-column label="销售订单号" align="left" prop="sn" show-overflow-tooltip width="130" />
      <el-table-column label="SAP销售单号" align="left" prop="sapOrderSn" width="130" show-overflow-tooltip />
      <el-table-column label="销售组织" align="left" prop="salesOrganizationName" show-overflow-tooltip width="150" />
      <el-table-column label="售达方" align="left" prop="soldToPartyName" show-overflow-tooltip />
      <el-table-column label="送达方" align="left" prop="deliverySideName" show-overflow-tooltip />
      <el-table-column label="rdm接口状态" align="left" prop="sapPush" width="130" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.sapPush == 1">成功</span>
          <span v-if="scope.row.sapPush == 2">失败</span>
        </template>
      </el-table-column>
      <el-table-column label="接口信息" align="left" prop="message" show-overflow-tooltip />
      <el-table-column label="备注" align="left" prop="note" show-overflow-tooltip />
      <el-table-column label="创建人" align="left" prop="createUser" show-overflow-tooltip />
      <el-table-column label="创建时间" align="left" prop="createTime" show-overflow-tooltip />
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status<=2" type="text" @click="handleEdit(scope.row.id, '修改')">修改</el-button>
          <el-button type="text" @click="handleEdit(scope.row.id, '查看')">查看</el-button>
          <el-dropdown v-if="scope.row.status===3" trigger="click" style="margin:0px 10px;" @command="handleCommand">
            <span class="el-dropdown-link">
              打印
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="'flotsam,'+scope.row.id">废料</el-dropdown-item>
              <el-dropdown-item :command="'mountings,'+scope.row.id">配件</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-if="scope.row.status<=1" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.status===3" v-permission="'order:salesOrder:index:del'" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="footer-box">
      <el-col :span="12" />
      <el-col :span="12">
        <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.size" @pagination="getPage" />
      </el-col>
    </el-row>

    <edit ref="edit" :show="showEdit" :edit-id="editId" @close="closeEdit" />
  </div>
</template>

<script>
import { getPage, deleteById, get } from '@/api/crm/order/salesOrder'
import Pagination from '@/components/Pagination'
import edit from './edit'
import ExcelImport from '@/components/ExcelImport'
import flotsam from '@/utils/printJson/flotsam'
import mountings from '@/utils/printJson/mountings'
import format from '@/utils/formatter'
import { downloadFile } from '@/utils/file'
export default {
  name: 'CustomerAlterIndex',
  components: { Pagination, ExcelImport, edit },
  data() {
    return {
      tableHeight: window.innerHeight - 200,
      showEdit: false,
      loading: false,
      editId: null,
      pagination: {
        total: 0,
        size: 20,
        current: 1
      },
      condition: {},
      tableData: [],
      statusOptions: [{ value: 1, label: '制单' }, { value: 2, label: '审核中' }, { value: 3, label: '审核完成' }]
    }
  },
  watch: {
    $route() {
      this.getPage()
    }
  },
  created() {
    this.getPage()
  },
  methods: {
    handleEdit(id, type) {
      this.showEdit = true
      this.editId = id
      this.$refs.edit.type = type
    },
    getPage(type) {
      this.loading = true
      if (type == 'refresh') {
        this.pagination.current = 1
      }
      // if (!this.condition.date) {
      //   this.condition.date = []
      // }
      getPage(this.condition, this.pagination)
        .then((reponse) => {
          const { current, total, size, records } = reponse.data
          this.tableData = records
          this.pagination.total = total
          this.pagination.current = current
          this.pagination.size = size
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete(id) {
      this.$confirm('请确认是否删除此数据', '提示', { type: 'warning' }).then(
        () => {
          console.log(id)
          deleteById(id).then((response) => {
            this.$message.success('删除成功')
            this.getPage()
          })
        }
      )
    },
    handleConditionExport() {
      exportExcel(this.condition, this.pagination).then((response) => {
        downloadFile(response)
      })
    },
    closeEdit() {
      this.showEdit = false
      this.getPage()
    },
    async handleCommand(e) {
      const type = e.split(',')[0]
      const id = e.split(',')[1]
      const response = await get(id)
      const { data } = response
      const mountingsList = []
      const flotsamList = []
      const info = JSON.parse(JSON.stringify(data))
      if (data.crmSalesOrdersLineModels && data.crmSalesOrdersLineModels.length > 0) {
        for (const item of data.crmSalesOrdersLineModels) {
          if (item.productType === 1) {
            mountingsList.push(item)
          } else {
            flotsamList.push(item)
          }
        }
      }
      if (type === 'mountings') {
        info.crmSalesOrdersLineModels = mountingsList
      } else {
        info.crmSalesOrdersLineModels = flotsamList
      }
      info.printDate = format.formatDate(new Date(), 'yyyy-MM-dd')
      this.$pluginName.init()
      const count = data.crmSalesOrdersLineModels.length >= 30 ? 30 : data.crmSalesOrdersLineModels.length
      const num = 15
      console.log(flotsam.panels[0])
      const footer = 260
      const one = 260
      const two = 300
      const three = 340
      if (type === 'mountings') {
        mountings.panels[0].paperFooter = footer + (num * count)
        mountings.panels[0].printElements[20].options.top = two + (num * count)
        mountings.panels[0].printElements[19].options.top = two + (num * count)
        mountings.panels[0].printElements[18].options.top = two + (num * count)
        mountings.panels[0].printElements[17].options.top = one + (num * count)
        mountings.panels[0].printElements[16].options.top = one + (num * count)
        mountings.panels[0].printElements[15].options.top = one + (num * count)
        mountings.panels[0].printElements[14].options.top = one + (num * count)
      } else {
        flotsam.panels[0].paperFooter = footer + (num * count)
        flotsam.panels[0].printElements[21].options.top = three + (num * count)
        flotsam.panels[0].printElements[20].options.top = three + (num * count)
        flotsam.panels[0].printElements[19].options.top = three + (num * count)
        flotsam.panels[0].printElements[18].options.top = two + (num * count)
        flotsam.panels[0].printElements[17].options.top = two + (num * count)
        flotsam.panels[0].printElements[16].options.top = two + (num * count)
        flotsam.panels[0].printElements[15].options.top = two + (num * count)
        flotsam.panels[0].printElements[14].options.top = one + (num * count)
      }
      // deliveryNote.panels[0].printElements[14].options.top = 305 + (num * count)
      var hiprintTemplate = new this.$pluginName.PrintTemplate(
        {
          template: type === 'mountings' ? mountings : flotsam,
          settingContainer: '#PrintElementOptionSetting',
          paginationContainer: '.hiprint-printPagination'
        }
      )
      // eslint-disable-next-line no-undef

      // debugger
      hiprintTemplate.print(info, {}, {
        callback: () => {
          console.log('浏览器打印窗口已打开')
        }
      })
    }
  }
}
</script>

  <style scoped>
.el-table >>> .el-table__fixed-body-wrapper {
  top: 30px !important;
}
</style>

